import { Injectable } from '@angular/core';
import {Config} from "../../config/config.service";

/**
 * A service to facilitate interaction with the global window object by registering
 * and unregistering functions dynamically at runtime.
 *
 */
@Injectable({ providedIn: 'root' })
export class WindowBridgeService {
  constructor(private config: Config) {
  }
  register(fnName: string, fn: (...args: any[]) => void) {
    if (this.config.CONFIG.provideSDKsupport) {
      (window as any)[fnName] = fn;
    }
  }

  unregister(fnName: string) {
    delete (window as any)[fnName];
  }
}
